import { RUN_NAME, type LampGameInfo } from '@goodtime/shared';

/**
 * The Wheel Run's cards on the slots without a road of their own, in plain
 * words (no Pixi, so they're tested on their own).
 */

/** The card when a star lights a lamp: it names the new game. `again`:
 *  the lamp offering its free game once more, from a tap on it. */
export function lampLitCard(
  game: Pick<LampGameInfo, 'slotName' | 'title'>,
  again = false,
): { title: string; line: string; sub: string } {
  return {
    title: again ? game.title.toUpperCase() : 'A NEW GAME',
    line: again ? `A game on ${game.slotName}: ${game.title}.` : `A new game on ${game.slotName}: ${game.title}.`,
    sub: `On the ${RUN_NAME} from now on`,
  };
}

/** The card a player sees once, on their first Wheel Run on a slot that
 *  had the Sweet Trail. */
export const WHEEL_RUN_CARD = {
  title: `A ${RUN_NAME.toUpperCase()} HERE`,
  line: `Every slot has a ${RUN_NAME} now. Your trail carries on, with a ${RUN_NAME} at the end.`,
} as const;

/** What a landing on a Wheel Run lamp says in the run's line. */
export function lampLandingText(game: Pick<LampGameInfo, 'title'>): string {
  return `The lamp opens ${game.title}!`;
}
